import { useAuth } from './useAuth';

/**
 * Hook to check if the current user is an admin
 * Admins can edit/delete orders and perform other privileged actions
 */
export function useIsAdmin(): boolean {
  const { role } = useAuth();
  return role === 'admin';
}

/**
 * Hook to check if the current user is a super admin (payslips + audit logs).
 * Backed by the `superAdmin` backend custom claim — see
 * scripts/onboard-tenant.mjs set-super-admin.
 */
export function useIsSuperAdmin(): boolean {
  const { superAdmin } = useAuth();
  return superAdmin;
}
